<template>
	<compact-banner
		:gradient-colors="{ primary: '#FF8C00', secondary: '#FF4500', tertiary: '#DC143C' }"
		:grid-color="'#FF8C008C'"
		css-class="new-user-promo-banner"
	>
		<div class="new-user-promo-text-container">
			<div class="new-user-promo-title">
				New User Promotion!
			</div>
			<div class="new-user-promo-subtitle">
				<span class="gradient-text">DOUBLE</span> your balance up to <b>$25</b> - Buy $10, get $20!
			</div>
			<div class="new-user-promo-button">
				<base-button
					@click="onAddFundsClick"
					large
					secondary-primary
					style="padding: 0 40px;"
				>
					Add Double Funds
				</base-button>
			</div>
		</div>
	</compact-banner>
</template>

<script>
import CompactBanner from '@/components/PromoBanners/CompactBanner.vue'
import BaseButton from '@/components/base/BaseButton.vue'

export default {
	name: 'NewUserPromoPromoBannerCompact',
	components: {
		CompactBanner,
		BaseButton
	},
	methods: {
		onAddFundsClick() {
			// This would open the add funds dialog
			this.$emit('add-funds-click')
		}
	}
}
</script>

<style lang="scss" scoped>
.new-user-promo-banner {
	.new-user-promo-text-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		height: 100%;
		width: 100%;
		z-index: 20;
		
		.new-user-promo-title {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #FFFBF0;
			font-weight: bold;
			font-size: 32px;
			margin: 0 0 8px 0;
			text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
			
			@media (max-width: 959px) {
				font-size: 28px;
			}
		}
		
		.new-user-promo-subtitle {
			font-size: 16px;
			color: #FFF8E7;
			font-weight: bold;
			text-wrap: normal;
			max-width: 600px;
			margin: 0 0 15px 0;
			line-height: 1.2;
			text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
			
			@media (max-width: 959px) {
				font-size: 14px;
				margin-bottom: 12px;
			}
		}
		
		.new-user-promo-button {
			display: flex;
			justify-content: center;
			width: 100%;
			
		}
		
		// Override the global gradient-text class with bright, contrasting colors
		.gradient-text {
			background: linear-gradient(90deg, #FFFACD, #FFD700 49%, #FFF8DC);
			-webkit-background-clip: text;
			background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: bold;
			text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
		}
	}
}
</style> 